export default __webpack_public_path__ + "static/media/icon-compare.a5e5d3e8.svg";